import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import ReferralVoucherUserStatisticsContainer from 'app/containers/Marketing/VoucherManagement/ReferralVoucherUserStatistics'

const ReferralVoucherUserStatisticsPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.referral_voucher_user_statistics)}</PageTitle>
      <ReferralVoucherUserStatisticsContainer />
    </>
  )
}
const ReferralVoucherUserStatisticsPage = memo(ReferralVoucherUserStatisticsPageCpn, isEqual)

export default ReferralVoucherUserStatisticsPage
